import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import HandleChange from '../../../../../../../Helpers/HandleChange';
import { toast } from 'react-toastify';
import routes from '../../../../../../../Routes/routes';
import {errorMsg, userListToLabelEmailPhoneValue} from '../../../../../../../Apis/functions';
import {
    CreateAttendanceShift, GetAttendanceShiftById,
    UpdateCreateAttendanceShift
} from '../../../../../../../reduxToolkit/AttendanceShift/AttendanceShiftApi';
import {MODEL_DATA} from '../Model/Models';
import {ATTENDANCE_SUBVIEW_MODEL, TABS_ATTENDANCE} from "../../../Model/Model";
import {PersonChipBlack} from "../../../../../../../components/buttons/IconButtons";

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle : Full Stack Developer - IBL
 * @Email : clopez@ibl.mx
 *
 */
const AddEditShiftAccessApp = () => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    let { state } = location;

    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);

    const [item, setItem] = useState({...MODEL_DATA});
    const [disabled, setDisabled] = useState(null);
    const [emptyFields, setEmptyFields] = useState(null);

    const [devices, setDevices] = useState([]);
    const [user, setUser] = useState([]);
    const [departments, setDepartments] = useState([]);
    const { handleChange } = HandleChange({ model: item, setModel: setItem });
    const [modified, setModified] = useState(false);

    useEffect(() => {
        if (id) {
            getData();
        }
    }, [id])

    useEffect(() => {
        if(modified && id){
            getData();
            setModified(false);
        }
    }, [modified])


    const getData = () => {
        dispatch(GetAttendanceShiftById(id)).then(({ payload: { data: { data, code } } }) => {
            setItem({...MODEL_DATA, id: data.id, name: data.name});
            setDevices(userListToLabelEmailPhoneValue(data.devices, 'id', false,null));
            setUser(userListToLabelEmailPhoneValue(data.users, 'userId', true, PersonChipBlack));
            setDepartments(userListToLabelEmailPhoneValue(data.departments, 'id', false, null));
        });
    }

    const handleAddEdit = () => {
        if (item.name == '' || devices.length <= 0) {
            setEmptyFields(true);
            toast.warn(t('please_fill_all_fields'));
            return;
        }
        let body =  item.toRegister(devices,departments,user);
        dispatch(item?.id ? UpdateCreateAttendanceShift(body) : CreateAttendanceShift(body)).then(({ payload: { data: { success, data, code } } }) => {
            if (success && data.id) {
                toast.success(t(item?.id ? 'has_been_updated_successfully' : 'has_been_created_successfully'));
                if(id){
                    setModified(true);
                } else navigate(routes.attendance.list, { state })
            } else errorMsg(code)
        });
    }

    const handleClearFields = () => {
        setItem({...MODEL_DATA});
        setDevices([]);
        setUser([]);
        setDepartments([]);
    }

    const handleOnBack = () => {
        navigate(routes.attendance.list, { state : {
            currentTab: TABS_ATTENDANCE.MANAGE.INDEX,
            currentSubView: ATTENDANCE_SUBVIEW_MODEL.MANAGE.SHIFT_ACCESS
        } });
    }

    return {
        id,
        t,
        DEV,
        permission,
        item, setItem,
        disabled, setDisabled,
        emptyFields, setEmptyFields,
        devices, setDevices,
        user, setUser,
        departments, setDepartments,
        handleChange,
        handleAddEdit,
        handleClearFields,
        handleOnBack
    }

}

export default AddEditShiftAccessApp
